.customScrollBar {
  position: relative;
  overflow: hidden;
  max-height: inherit;

  &Content {
    width: 100%;
    height: 100%;
    max-height: inherit;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      background-color: transparent;
      width: 0;
      height: 0;
    }
  }

  &Track {
    user-select: none;
    position: absolute;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
    padding: 1px;

    &Y {
      top: 0;
      right: 3px;
      width: 7px;
    }

    &X {
      bottom: 3px;
      left: 0;
      height: 7px;
    }
  }

  &Thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.4);

    &Y {
      width: 5px;
      min-height: 10px;
    }

    &X {
      height: 5px;
      min-width: 10px;
    }
  }
}
